<template>
    <div class="send-sms-code-btn">
        <div
            @click="onClickShowDialogBtn"
            class="show-dialog-btn"
        >
            {{ sendSmsBtnText }}
        </div>
        <puzzle-verification
            @finish="onSuccess"
            v-model="isDialogVisible"
        />
    </div>
</template>

<script>
import puzzleVerification from '@x-tech/puzzle-verification/dist/dialog';
import { helper } from '@x-tech/fe-puma-lib';
import * as authApi from '@/api/auth';

const COOL_DOWN_SECONDS = 60;
const regexHelper = helper.regex;


export default {
    name: 'SendMsgWithCaptcha',
    components: {
        puzzleVerification,
    },
    props: {
        phone: {
            type: String,
            required: true
        },
        typ: {
            type: String,
            required: true
        }
    },
    data: () => {
        return {
            sendSmsBtnText: '发送验证码',
            isDialogVisible: false,
        };
    },
    methods: {
        validForm() {
            if (!regexHelper.mobile.test(this.phone)) {
                this.$message.warning('请输入有效手机号');
                return false;
            }
            return true;
        },
        $_setSendSmsInCoolDown() {
            let time = COOL_DOWN_SECONDS;
            this.isSendSmsInCoolDown = true;

            clearInterval(this.sendSmsCoolDownTimer);
            this.sendSmsCoolDownTimer = setInterval(() => {
                if (time <= 0) {
                    this.isSendSmsInCoolDown = false;
                    this.sendSmsBtnText = '点击重新发送';
                } else {
                    this.sendSmsBtnText = `${time}秒`;
                    time -= 1;
                }
            }, 1000);
        },
        onClickShowDialogBtn() {
            if (!this.validForm() || this.isSendSmsInCoolDown) {
                return;
            }

            if (!this.validForm()) {
                return;
            }
            this.isDialogVisible = true;
        },
        handleClose() {
            this.isDialogVisible = false;
        },
        async onSuccess(res) {
            try {
                const { token, clientId } = res.data;
                await authApi.sendSms({
                    phone: this.phone,
                    code: token,
                    clientId,
                    type: this.typ
                });
            } catch (e) {
                console.error(e);
                return;
            } finally {
                this.isDialogVisible = false;
            }

            this.$_setSendSmsInCoolDown();
            this.$message.success('验证码发送成功，请注意查收');
        }
    }
};
</script>

<style lang="scss" scoped>
.box {
  text-align: center;
  min-height: 200px;
}
.send-sms-code-btn{
  display: inline-block;
}
.show-dialog-btn {
  cursor: pointer;
  white-space: nowrap;
}
</style>
